module.exports = __webpack_public_path__ + "static/004163-29b10a80daf98e3421cf88dc253dd96f.jpg";